import assets from "assets";
import Button from "components/widgets/button";
import { FiUserPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import { firebaseAuth } from "utils/config/firebase.config";
import resources from "utils/helpers/resourses";
import useAuth from "utils/hooks/useAuth";

function TopNav() {
  const auth = useAuth();
  return (
    <div className="bg-white w-screen fixed top-0 border-b z-50">
      <div className="flex items-center justify-between h-16  px-4">
        <Link to="/">
          <img src={assets.logo} alt="TextHere" className="h-9 animate hover:scale-105 cursor-pointer select-none hidden sm:block" />
          <img src={assets.icon} alt="TextHere" className="h-9 animate hover:scale-105 cursor-pointer select-none sm:hidden" />
        </Link>

        {/* <Search className="flex-grow mx-8 max-w-lg hidden md:flex" slim={true} /> */}
        <div className="flex-grow"></div>
        <Link to="/docs" className="mr-4">
          <Button label="Docs" type="FLAT" />
        </Link>
        {auth ? (
          <div onClick={() => firebaseAuth.signOut()} className="flex items-center">
            <p className="">{auth.displayName}</p>
            <img
              src={auth.photoURL || resources.avatar_image}
              alt=""
              className="w-12 h-12 object-cover ml-4 rounded-full border-2 border-transparent hover:border-primary  hover:scale-110 animate cursor-pointer"
              onError={(e) => {
                e.currentTarget.src = resources.avatar_image;
              }}
            />
          </div>
        ) : (
          <Link to="/join">
            <Button label="Get Started" icon={<FiUserPlus />} />
          </Link>
        )}
      </div>
      {/* <div className="md:hidden flex items-center justify-between h-16 container mx-auto px-4">
        <Search className="flex-grow mx-8" slim={true} />
      </div> */}
    </div>
  );
}

export default TopNav;
